import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { CalendarDays, ChevronDown } from 'lucide-react';
import SepaMiniAgenda from './SepaMiniAgenda';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Agenda global repliable — RDV & envois planifiés de tous les plans SEPA. */
export default function SepaAgendaGlobal() {
  const { getAuthHeader } = useAuth();
  const [open, setOpen] = useState(false);
  const [events, setEvents] = useState([]);
  const headers = useCallback(() => ({ headers: getAuthHeader() }), [getAuthHeader]);

  const fetchEvents = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/sepa-stripe/admin/agenda-global`, headers());
      setEvents(r.data?.events || []);
    } catch (e) {
      // non bloquant
    }
  }, [headers]);

  useEffect(() => { if (open) fetchEvents(); }, [open, fetchEvents]);

  return (
    <div className="bg-white border border-slate-200/80 rounded-2xl overflow-hidden" data-testid="sepa-agenda-global">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-3 text-left hover:bg-slate-50 transition-colors"
        data-testid="sepa-agenda-global-toggle"
      >
        <span className="flex items-center gap-2 text-sm font-bold text-[#0a3d62]">
          <CalendarDays className="h-4 w-4" /> Agenda global — RDV &amp; envois planifiés (tous les plans)
        </span>
        <span className="text-xs text-slate-500 flex items-center gap-1">
          {open ? 'Replier' : 'Déplier'} <ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
        </span>
      </button>
      {open && (
        <div className="px-4 pb-4">
          <SepaMiniAgenda
            events={events}
            showPlanRef
            testid="sepa-agenda-global-cal"
            onAdd={() => toast.info('Ajoutez un RDV depuis la fiche du plan concerné')}
            onMove={async (evId, newDate) => {
              const ev = events.find((x) => x.id === evId);
              if (!ev || ev.date === newDate) return;
              try {
                await axios.put(`${API}/sepa-stripe/admin/agenda/${evId}`, { date: newDate, label: ev.label }, headers());
                await fetchEvents();
              } catch (e) {
                toast.error('Déplacement impossible');
              }
            }}
            onDelete={async (ev) => {
              try {
                await axios.delete(`${API}/sepa-stripe/admin/agenda/${ev.id}`, headers());
                await fetchEvents();
              } catch (e) {
                toast.error('Suppression impossible');
              }
            }}
          />
        </div>
      )}
    </div>
  );
}
